module.exports = __webpack_public_path__ + "static/media/in-duel.72593672.gif";